import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const reopenSolicitationThunk = createAsyncThunk(
    `ReopenSolicitationSlicer/reopenSolicitationThunk`,
    async ({ solicitationId, note }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const config = { headers };

        const body = {
            note,
        };

        const { data } = await conciergeApiClient.post(
            `Redemption/${solicitationId}/reopen`, body, config
        );

        return data;
    }
);

const initialState = {
    dataReopenSolicitation: false,
    loadingReopenSolicitation: false,
    errorReopenSolicitation: false,
};

const ReopenSolicitationSlicer = createSlice({
    name: 'ReopenSolicitation',
    initialState,
    reducers: {
        resetDataReopenSolicitation: (state) => {
            state.dataReopenSolicitation = false;
            state.loadingReopenSolicitation = false;
            state.errorReopenSolicitation = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(reopenSolicitationThunk.pending, (state) => {
            state.dataReopenSolicitation = false;
            state.loadingReopenSolicitation = true;
            state.errorReopenSolicitation = false;
        });
        builder.addCase(reopenSolicitationThunk.fulfilled, (state, action) => {
            state.dataReopenSolicitation = true;
            state.loadingReopenSolicitation = false;
            state.errorReopenSolicitation = false;
        });
        builder.addCase(reopenSolicitationThunk.rejected, (state) => {
            state.dataReopenSolicitation = false;
            state.loadingReopenSolicitation = false;
            state.errorReopenSolicitation = true;
        });
    },
});

export const { resetDataReopenSolicitation } = ReopenSolicitationSlicer.actions;
export default ReopenSolicitationSlicer.reducer;